import $http from '@/services/HttpService';

const route = '/airports';

export default {
  createAirport(data) {
    /* eslint-disable no-param-reassign */
    delete data.id;
    /* eslint-enable no-param-reassign */
    return $http.post(route, data);
  },

  getAirports() {
    return $http.get(route, { params: { projections: 'id,code,published' } });
  },

  getAirport(id) {
    return $http.get(`${route}/${id}`);
  },

  getAirportCode(id) {
    return $http.get(`${route}/${id}`, { params: { projections: 'id,code' } });
  },

  updateAirport(data) {
    return $http.put(`${route}/${data.id}`, data);
  },

  deleteAirport(id) {
    return $http.delete(`${route}/${id}`);
  },

  getAirportSections(id) {
    return $http.get(`${route}/${id}`, { params: { projections: 'sections' } });
  },

  getAirportStores(id) {
    return $http.get(`${route}/${id}/stores`, { params: { projections: 'id,name,type,location' } });
  },

  getAirportStore(airportId, storeId) {
    return $http.get(`${route}/${airportId}/stores/${storeId}`);
  },

  createAirportStore(airportId, data) {
    /* eslint-disable no-param-reassign */
    delete data.id;
    /* eslint-enable no-param-reassign */
    return $http.post(`${route}/${airportId}/stores`, data);
  },

  deleteAirportStore(airportId, storeId) {
    return $http.delete(`${route}/${airportId}/stores/${storeId}`);
  },

  updateAirportStore(airportId, storeId, data) {
    return $http.put(`${route}/${airportId}/stores/${storeId}`, data);
  },

  publishAirport(id) {
    return $http.post(`${route}/${id}/publish`);
  },

  unpublishAirport(id) {
    return $http.post(`${route}/${id}/unpublish`);
  },
};



// WEBPACK FOOTER //
// ./src/services/AirportsService.js